<template>
  <div class="dashboard">
    <ProgressHUD
        ref="progress"
        :display="false"
    />

    <layout-main>

      <div>
      <div class="row">
          <div class="col-lg-12">
              <h4 class="page-header">Solar Edge</h4>
          </div>
      </div>
      <div class="row top-row">
          <div class="col-lg-5 col-md-5 col-xs-12">
                                                   
                        <div class="panel panel-green weather"> 
                            <div class="panel-heading top-panel-heading">Weather</div>
                            <div class="panel-content wheather-line">
                          <!--       <div class="col-lg-4 col-md-6">
                                    <ul class="citymenu" v-if="profileData && profileData.user.citiesForWeather.length > 0">
                                        <li v-for="(item, key) in profileData.user.citiesForWeather"><a class="town" :class="{'active': (key==activeId)}" @click="changeWeather(item,0,0, key)">{{item}}</a></li>
                                    </ul>
                                    <a class="town active town1" v-else>{{city}}</a>
                                    
                                </div> -->
                                <div class="col-lg-4 col-md-6 condition" style="text-align:center;">
                                    <img :src="conditionIcon" class="tac img">
                                    <span class="tac ccc">{{tempC}}&deg;C</span>
                                </div>
                                <div class="col-lg-4 col-md-6 wind">
                                    <img src="/../static/dist/images/wheather2.png">
                                    <span class="tac ccc">NNW {{wind}} km/h</span>
                                    
                                    
                                </div>
                            </div>
                        </div>                   
              
          </div>

      </div>

<!--       <div class="row top-row row-line my-projects">
          <div class="col-lg-7 col-md-7 col-xs-12 my-production">
              <div class="panel panel-green">
                  <div class="panel-heading top-panel-heading">GREEN FUND</div>

                  <div class="panel-content p-block projects"> 
                    <div class="no-project">
                      <p>Coming soon.</p>
                      <br>
                      <p>GREEN Fund is our crowd investing platform for projects in renewable energy and social impact.</p>
                    </div>
                  </div>
              </div>
          </div>

          <div class="col-lg-5 col-md-5 col-xs-12 my-production">
              <div class="panel panel-green">
                  <div class="panel-heading top-panel-heading">Investments</div>

                  <div class="panel-content p-block projects"> 
                    <div class="no-project">
                      <p>Coming soon.</p>
                      <br>
                      <p>GREEN Fund is our crowd investing platform for projects in renewable energy and social impact.</p>
                    </div>
                  </div>
              </div>
          </div>          
      </div>  -->  
      </div>   
      <!-- <button v-on:click="backToGREEN()" type="button" class="btn btn-back">Back</button> -->

      <!-- <form data-vv-scope="firstForm" >
                <h4 class="form-h4">information</h4>
                <div class="row form-line">
                    <div class="col-lg-6 col-md-6">
                        <div class="form-group">
                            <div class="add-product add-project">
                                <ul>
                                    <li>
                                        <label>Name*</label>
                                        <span class="inp-block">                                          
                                        <input name="Name" class="form-control" :class="{'error-input': errors.has('firstForm.Name')}" type="text" placeholder="" name="Name" v-validate="'required'" data-vv-as="Name">
                                        
                                        <span
                                          v-if="errors.has('firstForm.Name')"
                                          class="error"
                                        >{{ errors.first('firstForm.Name') }}</span> 
                                        </span>
                                    </li>                                 
                                    <li> 
                                        <label>Select Type of Green Energy*</label>
                                        <span class="inp-block"> 
                                          <select
                                              name="Type"
                                              v-validate="'required'"
                                              
                                              data-vv-as="Type"
                                              :class="{'error-input': errors.has('firstForm.Type')}"
                                             
                                          >
                                              <option value="" disabled selected></option>
                                              
                                          </select>
                                          <span
                                              v-if="errors.has('firstForm.Type')"
                                              class="error"
                                          >{{ errors.first('firstForm.Type') }}</span>
                                        </span>
                                    </li>
                                    <li >
                                        <label>Enter Inverter Type*</label>
                                          <span class="inp-block">                                          
                                            <input class="form-control" :class="{'error-input': errors.has('firstForm.TypeInverter')}" v-validate="" type="text" placeholder="" name="TypeInverter" data-vv-as="Type of Inverter">                                          
                                            <span
                                              v-if="errors.has('firstForm.otherinverter')"
                                              class="error"
                                            >{{ errors.first('firstForm.otherinverter') }}</span>
                                          </span>
                                    </li>  
                                </ul>
                              </div>
                            </div>
                          </div>
                        </div>
                    </form>    -->

<!--                     <div class="col-lg-4 col-md-6">
                        <div class="panel panel-green weather"> 
                            <div class="panel-heading top-panel-heading">Weather</div>
                            <div class="panel-content wheather-line">
                                <div class="col-lg-4 col-md-6">
                                    <ul class="citymenu" v-if="profileData && profileData.user.citiesForWeather.length > 0">
                                        <li v-for="(item, key) in profileData.user.citiesForWeather"><a class="town" :class="{'active': (key==activeId)}" @click="changeWeather(item,0,0, key)">{{item}}</a></li>
                                    </ul>
                                    <a class="town active town1" v-else>{{city}}</a>
                                    <a class="town">Lima</a>
                                </div>
                                <div class="col-lg-4 col-md-6 condition" style="text-align:center;">
                                    <img :src="conditionIcon" class="tac img">
                                    <span class="tac ccc">{{tempC}}&deg;C</span>
                                </div>
                                <div class="col-lg-4 col-md-6 wind">
                                    <img src="static/dist/images/wheather2.png">
                                    <span class="tac ccc">NNW {{wind}} km/h</span>
                                    <a v-on:click.stop="openAddcity()">Select city</a>
                                    <ModalDialogAddCity ref="addcity" />
                                </div>
                            </div>
                        </div>
                    </div> -->   
    </layout-main>
  </div>                    
</template>

<style>
  
.btn-green {    
    background: #55be68;
    color: #fff;
    padding: 7px 16px;
    border-radius: 100px;
    font-weight: 500;
    box-shadow: 0px 3px 5px #ccc;
    line-height: normal;
    font-size: 15px;
    transition: 0.3s;
    margin: 0 auto;
    display: inline-block;
}
.block_green { padding-left: 35px; }

</style>

<script>
import LayoutMain from './../../layouts/LayoutMain.vue';
import ProgressHUD from './../ProgressHUD/index.vue'
import Footer from './../Footers/Footer/index.vue'
import LineChart from './../../data/LineChart.js'
import { Api, Toast } from './../../services'

export default {
  name: 'SolarEdge',
  props: [],
  components: {
    LayoutMain,
    ProgressHUD,
    Footer,
    LineChart,
  },
  data() {
    return {
      profileData: null,
      sumTokens: 0,
      productUnAnswComments: {},
      totalProductUnAnswComments: 0,
      serviceUnAnswComments: {},
      totalServiceUnAnswComments: 0,
      lat: 51.508530,
      lng: -0.076132,
      validResponse: "",
      city: "London",
      location: "United Kingdom",
      hours: 0,
      mins: 0,
      day: "",
      temp: true,
      tempC: "",
      tempF: "",
      conditionText: "",
      conditionIcon: "https:",
      humidity: "",
      precip: "",
      wind: 0,
      windmph: 0,
      activeId: 0,
      datacollection: {},
      heightChart: 0,
      sumGreenCertificates: 0,
      sumBonusCarbon: 0,
      itemsCarousel: 3.25,
      green: 0,
    }
  },
  methods: {
    // backToGREEN() {
    //   this.$router.go(-1);
    // },
    goToDetailPage(project) {
      // $('#exampleModalCenter').modal('close');
      this.$router.push("/project/systemsdetail/existing/" + project._id)
    },
    openReport(project) {
      this.$refs.sendReport.openReport(project)
    },
    goToDuplicatePage: function(project) {
      this.$router.push("/project/systemsdetail/existing/duplicate/" + project._id)
    },
    async saveWallet() {
      try {          
          var formData = new FormData()
          formData.append('walletAddressGREEN', this.profileData.user.walletAddressGREEN)
          formData.append('contractAddressGREEN', this.profileData.user.contractAddressGREEN)
          var response = await Api.saveWalletGREEN(formData)
          if (response.data) {
            $('.modal').modal('hide')
            $('.modal-backdrop.in').remove()
            Toast.success({
               toast: this.$toast,
              title: 'Success!',
              message: 'Payment Methods Successfully Saved',
            })
          }
      } catch (error) {
          console.error(error)
          this.validationMessage = error.messageisGreen=true;

          Toast.error({
            toast: this.$toast,
            title: 'Error',
            message: error.message,
          })
        } finally {
          this.$refs.progress.hide()
        }      
    },
    fetchData() {
      let self = this;
      // prompt for location zipCode / city name / latitude / ip address
      // console.log(`longitude 22 : ${ this.lng } | latitude 22 : ${ this.lat }`);

                let location = (this.lat==0 && this.lng==0) ? this.city : this.lat + "," + this.lng;

                if (location === null) {
                    console.log("Cancelled request...try again!");
                    return;
                } else {
                  //36d24e2c59324195b3d134523192201 - my key

                    axios.get("http://api.weatherstack.com/forecast?access_key=dc6b40af6f4c00193ccf4b1ceff4296d&query=" + location)
                        .then(function (response) {
                            if (response.status != 200) {
                                self.validResponse = false;
                            } else {
                                self.validResponse = true;

                                // obtain city name, country, temperature, cloud icon,
                                //  cloud info, humidity, wind, precipitation from api
                                self.city = response.data.location.name;
                                self.tempC = Math.floor(response.data.current.temperature);
                                self.conditionText = response.data.current.weather_descriptions[0];
                                self.conditionIcon = response.data.current.weather_icons[0];
                                self.humidity = response.data.current.humidity;
                                self.location = response.data.location.country;
                                self.wind = Math.floor(response.data.current.wind_speed);
                                self.windmph = Math.floor(response.data.current.wind_degree);
                                self.precip = response.data.current.precip;

                                // get hours from api
                                let date = new Date(response.data.location.localtime);
                                self.hours = date.getHours();
                                console.log("self----------")
                                console.log(self)
                                // format time minutes
                                if (date.getMinutes() < 10) {
                                    self.mins = "0" + date.getMinutes();
                                } else {
                                    self.mins = date.getMinutes();
                                }

                                // format day of week
                                let days = ["Sun", "Mon", "Tue", "Wed", "Thur", "Fri", "Sat"];

                                for (let i = 0; i < days.length; i++) {
                                    if (date.getDay() === i) {
                                        self.day = days[i];
                                    }
                                }
                            }
                        })
                        .catch(function (error) {
                            console.log(`Bad Request: ${error}`);
                        });
                }
    },
    // Function for create data collection
    createDataCollection(labels, datasets) {
      return {
        labels: labels,
        datasets: datasets
      }
    },
    refreshDataForChart() {

      if (this.profileData.projectsExist || this.profileData.projectsExist[0] == undefined || this.profileData.projectsExist[0] == null) return

      this.heightChart = (window.innerHeight >= 850) ?  200 : 180;
     console.log("*********************************"+this.heightChart)



      // set data for charts
      this.datacollection.labels = []
      this.datacollection.datasets = []
      var bg = ["rgba(91, 155, 213, 1)", "rgba(237, 125, 49, 0.2)","rgba(65, 105, 225, 0.5)", "rgba(0, 250, 154, 1)",
                "rgba(238, 130, 238, 1)", "rgba(0, 128, 128, 0.3)","rgba(147, 112, 216, 1)", "rgba(216, 112, 147, 1)",
                "rgba(104, 142, 35, 1)", "rgba(255, 165, 0, 1)","rgba(112, 128, 144, 0.3)", "rgba(91, 155, 213, 0.2)", "rgba(237, 125, 49, 0.2)","rgba(65, 105, 225, 0.5)", "rgba(0, 250, 154, 1)",
                "rgba(238, 130, 238, 1)", "rgba(0, 128, 128, 0.3)","rgba(147, 112, 216, 1)", "rgba(216, 112, 147, 1)",
                "rgba(104, 142, 35, 1)", "rgba(255, 165, 0, 1)","rgba(112, 128, 144, 0.3)", "rgba(0, 250, 154, 0.1)"]

      var timeLine = 0
      if (this.typeChart == 'week') timeLine = 7
      else timeLine = 29

      var curentDate = new Date()
      var timePeriod = {
        first: new Date(
          curentDate.getFullYear(),
          curentDate.getMonth(),
          curentDate.getDate() - timeLine
        ),
        last: new Date(
          curentDate.getFullYear(),
          curentDate.getMonth(),
          curentDate.getDate()
        ),
      }

      // Get time period for filter
      for(var i=0; i < this.profileData.projectsExist.length; i++) {
        var actualData = [], ipvDateArr = []
        for (var indexForIpvData in this.profileData.projectsExist[i].ipv) {
          var ipvDataByDay = this.profileData.projectsExist[i].ipv[indexForIpvData]
          if (!ipvDataByDay) {
            console.log('IPV Data is null' + this.profileData.projectsExist[i]._id)
            continue
          }

          var ivpDate = this.parseDate(ipvDataByDay.date)

          if (timePeriod.first <= ivpDate && ivpDate <= timePeriod.last) {
            actualData.push(ipvDataByDay.actual)
            //ipvDateArr.push(ipvDataByDay.date)
            this.datacollection.labels.push(ipvDataByDay.date)
          }
        }
        // console.log("actualData*****************************" + bg[i])
        // console.log(actualData)
        // console.log(this.profileData.projectsExist[i].name)
        // this.datacollection.labels.push(ipvDateArr)
        this.datacollection.datasets.push({
            label: this.profileData.projectsExist[i].name,
            data: actualData,
            backgroundColor: bg[i],
            borderColor: bg[i],
            borderWidth: 1,
            fill: false
        })

      }


      this.datacollection = this.createDataCollection(
        this.datacollection.labels,
        this.datacollection.datasets
      )
    },
    parseDate(input) {
      var parts = input.split('/')
      return new Date(parts[0], parts[1] - 1, parts[2])
    },
    refreshSize(event) {
      var ctx = document.getElementById("line-chart");
      console.log(ctx)
      // ctx.canvas.width = 200;
      if (ctx != null && ctx != "null") ctx.height = 200; 
      this.refreshDataForChart()
    },
  },
  getD() {
    return 8;
  },
  async created() {
    
    try {
      var _s = this

      var response = await Api.myProfile()
      setTimeout(_s.fetchData(), 55000);
      if (response.data) {
        this.profileData = response.data.results
        console.log("profileData>>>>>>>>>>>>>>>>>")
        console.log(this.profileData)

        var sumTokens = 0, sumGreenCertificates = 0, sumBonusCarbon =0, pExist = this.profileData.projectsExist;

        for (var i=0; i<pExist.length; i++){
          sumGreenCertificates = sumGreenCertificates + pExist[i].greenCertificates
          sumBonusCarbon = sumBonusCarbon + pExist[i].bonusCarbon
          for (var j=0; j<pExist[i].sentTokens.length; j++)
            sumTokens = sumTokens + pExist[i].sentTokens[j].amount
        }
        this.sumTokens = sumTokens
        this.sumGreenCertificates = sumGreenCertificates
        this.sumBonusCarbon = sumBonusCarbon
        if (this.profileData.balanceETH)
          this.green = this.profileData.balanceETH[1].toFixed(2) 
        
        this.$localStorage.get('userName')

        this.profileData.comments.forEach(item => {
          if (typeof item.product[0] !== 'undefined' && item.product[0]["user"][0] === this.profileData.user._id) {
            if (item.product[0]['type'] === 'Service' ) {
              this.serviceUnAnswComments[item.product[0]['_id']] = (typeof this.serviceUnAnswComments[item.product[0]['_id']] === 'undefined') ? 1 : parseInt(this.serviceUnAnswComments[item.product[0]['_id']]) + 1
              this.totalServiceUnAnswComments++
            } else if (item.product[0]['type'] === 'Product' ) {
              this.productUnAnswComments[item.product[0]['_id']] = (typeof this.productUnAnswComments[item.product[0]['_id']] === 'undefined') ? 1 : parseInt(this.productUnAnswComments[item.product[0]['_id']]) + 1
              this.totalProductUnAnswComments++
            }
          }
        })

        if(pExist.length > 0){
          this.lat = pExist[0].latitude;
          this.lng = pExist[0].longitude;
          // this.activeId = pExist[0]._id;
          this.activeId = 0;
          //this.city = this.profileData.user.citiesForWeather[0]
          this.fetchData();
        }
        this.refreshDataForChart()

        await new Promise(resolve => this.$nextTick(resolve));

        
        if($(window).width()<=500)
          this.itemsCarousel = 1.25
        else if($(window).width()<=991)
          this.itemsCarousel = 2.25

         var loopCarousel = (this.profileData.projectsExist.length > 3) ? true : false
        $('.owl-carousel').owlCarousel({
          stagePadding: 50,
          loop: true,
          margin: 20,
          navText: [
            '<i class="fa fa-angle-left" aria-hidden="true"></i>',
            '<i class="fa fa-angle-right" aria-hidden="true"></i>'
          ],
          navContainer: '.custom-nav',
          loop: loopCarousel,
          nav: false,
          dots: false,
          responsive: {
            0:{
                items: 1.25
            },
            500:{
                items: 2.25
            },
            1000:{
                items: 3.25
            }
          }
          //items: this.itemsCarousel
        });

        if (this.profileData.user.walletAddressGREEN=='' && this.profileData.user.created > 1586908800000 && this.profileData.user.social_auth!='') {
          $('.modal').modal({
            backdrop: 'static',
            keyboard: false
          })
          $('.modal').modal('show')
        }  
      } else {
        this.validationMessage = 'Something went wrong.'

        Toast.error({
          toast: this.$toast,
          title: 'Error',
          message: 'Something went wrong.',
        })
      }

    } catch (error) {
      console.error(error)
      this.validationMessage = error.message

      Toast.error({
        toast: this.$toast,
        title: 'Error',
        message: error.message,
      })
    } finally {
      this.$refs.progress.hide()
    }
  },
   mounted() {
    window.addEventListener('resize', this.refreshSize)
  },
}
</script>



// WEBPACK FOOTER //
// src/components/Project/SolarEdge.vue